import { Route } from 'react-router-dom';
import { ExperienceActionList } from './list';

export const ExperienceActionsRoute = (
  <Route path="actions">
    <Route index element={<ExperienceActionList />} />
  </Route>
);
